import { forwardRef, type InputHTMLAttributes, useId } from 'react';
import { cn } from '@/shared/lib/cn';
import './Input.css';

export type InputState = 'default' | 'success' | 'error';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: string;
  state?: InputState;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { label, hint, state = 'default', className, id, ...rest },
  ref,
) {
  const autoId = useId();
  const inputId = id ?? `itb-input-${autoId}`;
  const hintId = hint ? `${inputId}-hint` : undefined;

  return (
    <div className="itb-input-group">
      {label && (
        <label htmlFor={inputId} className="itb-input__label">
          {label}
        </label>
      )}
      <input
        id={inputId}
        ref={ref}
        aria-describedby={hintId}
        aria-invalid={state === 'error' || undefined}
        className={cn('itb-input', `itb-input--${state}`, className)}
        {...rest}
      />
      {hint && (
        <div id={hintId} className={cn('itb-input__hint', `itb-input__hint--${state}`)}>
          {hint}
        </div>
      )}
    </div>
  );
});
